import 'styles/homepage.scss'
import 'styles/bswConnect.scss'
import {Urls} from '../constants/index.js'


(function () {
    /* global $ */
    "use strict";  

    const authSettings = $.sc.authSettings;
  
    async function getPaListEndpoint() {
        const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/api/PublishedProviderProfile/List`);
    
        endpoint.searchParams.set('DistanceInMeters', '80467');
        endpoint.searchParams.set('ItemsPerPage', '-1');
        endpoint.searchParams.set('Page', '1');
        endpoint.searchParams.set('SortColumn', 'Nickname');
        endpoint.searchParams.set('SortType', 'asc');
    
        const response = await fetch(endpoint);
        const data = await response.json();
        return data;
    }

    async function getVacanciesListEndpoint() {
		const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/api/PublishedParticipantVacancy/List`);
    
        endpoint.searchParams.set('DistanceInMeters', '80467');
        endpoint.searchParams.set('ItemsPerPage', '-1');
        endpoint.searchParams.set('Page', '1');
        endpoint.searchParams.set('SortColumn', 'Nickname');
        endpoint.searchParams.set('SortType', 'asc');
    
        const response = await fetch(endpoint);
        const data = await response.json();
        return data;
	}


    async function createMyPaPanel() {
        const getPAs = await getPaListEndpoint();
        const getVacancies = await getVacanciesListEndpoint();

        if(getPAs.Data.Paging.TotalItemsCount=== 1){
            $('.js-available-pa .h3').text(`${getPAs.Data.Paging.TotalItemsCount}`)
            $('.js-available-pa p').text('Available PA in your area')
          
        } else if(getPAs.Data.Paging.TotalItemsCount === -1){
            $('.js-available-pa .h3').text('0')
            $('.js-available-pa p').text('Available PAs in your area')
           
        }else{
            $('.js-available-pa .h3').text(`${getPAs.Data.Paging.TotalItemsCount}`)
            $('.js-available-pa p').text('Available PAs in your area')
           
        }


        if(getVacancies.Data.Paging.TotalItemsCount === 1){
            $('.js-available-vacancies .h3').text(`${getVacancies.Data.Paging.TotalItemsCount}`)
            $('.js-available-vacancies p').text('Available vacancy in your area')
          
        } else if(getVacancies.Data.Paging.TotalItemsCount === -1){
            $('.js-available-vacancies .h3').text('0')
            $('.js-available-vacancies p').text('Available vacancies in your area')
           
        }else{
            $('.js-available-vacancies .h3').text(`${getVacancies.Data.Paging.TotalItemsCount}`)
            $('.js-available-vacancies p').text('Available vacancies in your area')
           
        }

    }    

    
    function createHomePage() {
        createBody();
        createMyPaPanel()
    }

    function createBody(){


        $('.js-homePage').append(
            `
            <h1 style="text-indent: -10000px; height: 0; margin: 0; padding: 0;">Welcome to Bath & North East Somerset, Swindon & Wiltshire PA WEB!</h1>
            <section class="intro-container" aria-label="Bath & North East Somerset, Swindon & Wiltshire PA WEB Intro">
                <div class="intro">
                    <div id="intro-item-1" class="intro-item container">
                        <div class="intro-item-text pcg-contrast__bg-alt">
                            <div><span class="intro-dark-blue pcg-contrast__color-alt">Bath & North East</span> </br> <span class="intro-pink pcg-contrast__color-alt">Somerset, Swindon &</span> </br><span class="intro-green pcg-contrast__color-alt">Wiltshire</span> <span class="pcg-contrast__color-alt">PA WEB</span></div>
                            <p>Find information and advice about working as or employing a
                            Personal Assistant in Care. You can also browse PA Profiles,
                            local vacancies and send messages.</p>
                        </div>
                        <div class="intro-item-img">
                            <img src="/resources/Councils/BSW/img/intro.jpg" alt="">
                        </div>
                    </div>                  
                </div>
            </section>

            <section class="looking-for-container-er container pcg-contrast__bg-alt" aria-label="What do you need help with">
                <h2>I am looking for?</h2>
                <div class="looking-for-content">
                    <article aria-labelledby="article-1" class="looking-for-tile pcg-contrast__bg-main">
                        <div>
                            <img src="/resources/Councils/BSW/img/employer.jpg" alt="I am a PA">
                        </div>
                        <a id="article-1" class="pcg-contrast__link" href="/s4s/CustomPage/Index/${Urls.infoForEmployersPage}">Information about being an employer</a>
                    </article>
                    <article aria-labelledby="article-2" class="looking-for-tile pcg-contrast__bg-main">
                        <div>
                            <img src="/resources/Councils/BSW/img/pa.jpg" alt="Information about being a PA">
                        </div>
                        <a id="article-2" class="pcg-contrast__link" href="/s4s/CustomPage/Index/${Urls.infoForProvidersPage}">Information about being a PA</a>
                    </article>
                </div>
            </section>

            <section class="available-container-er pcg-contrast__bg-alt" aria-label="Available PAs">
                <div class="container">
                    <h2>Right now there are...</h2>
              
                    <div class="available-content">
                        <div class="available-tile">
                            <div class="available-tile-text pcg-contrast__bg-main js-available-pa">
                                <span class="h3 pcg-contrast__color-main"></span>
                                <p></p>
                                <a class="plain-btn-er pcg-contrast__btn"  href="/s4s/CustomPage/Index/${Urls.pa_search}">Search for PA</a>
                            </div>
                            <div class="available-tile-image">
                                <img src="/resources/Councils/BSW/img/available-pa.jpg" alt="Available PA">
                            </div>
                        </div>
                        <div class="available-tile">
                            <div class="available-tile-text pcg-contrast__bg-main js-available-vacancies">
                                <span class="h3 pcg-contrast__color-main"></span>
                                <p>Available vacancies in your area</p>
                                <a class="plain-btn-er pcg-contrast__btn"  href="/s4s/CustomPage/Index/${Urls.vacancies_search}">Search vacancies</a>
                            </div>
                            <div class="available-tile-image">
                                <img src="/resources/Councils/BSW/img/available-vacancies.jpg" alt="Available Vacancies">
                            </div>
                        </div>
                    </div>
                </div>
               
            </section>

            <section class="news-container-er container pcg-contrast__bg-alt" aria-label="News">
                <h2>Hear what people are saying</h2>
                <p>Lorem ipsum dolor sit amet consectetur. Sit convallis pulvinar amet lacinia vel pellentesque lectus. Pharetra id pharetra
                lacus urna phasellus tempus laoreet faucibus. Tellus ullamcorper etiam semper porta. Ullamcorper non in tristique aliquam
                lectus. Diam pellentesque tincidunt interdum pretium tellus lectus.</p>
                <div class="available-content">
                    <div class="available-tile ">
                        <div class="available-tile-image">
                            <img src="/resources/Councils/BSW/img/find-a-pa.jpg" alt="News 1">
                        </div>
                        <div class="available-tile-text pcg-contrast__bg-alt">
                            <h3>Lorem ipsum dolor</h3>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean rutrum nisi e</p>
                            <a class="plain-btn-er pcg-contrast__btn"  href="/">Read Sarah's story</a>
                        </div>
                    </div>
                    <div class="available-tile">
                        <div class="available-tile-image">
                            <img src="/resources/Councils/BSW/img/employer.jpg" alt="News 2">
                        </div>
                        <div class="available-tile-text pcg-contrast__bg-alt">
                            <h3>Lorem ipsum dolor</h3>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean rutrum nisi e</p>
                            <a class="plain-btn-er pcg-contrast__btn"  href="/">Read Sarah's story</a>
                        </div>
                    </div>
                </div>
               
            </section>

            `
        )
    }
    

    var Attributes = {
        init: function () {
            this.adjustDom();
            this.bindUIActions();
            this.unload();
        },

        adjustDom: function () {
            if (authSettings.login === null || window.location.href.includes('?homepage=view')){
                createHomePage();
            }else if (authSettings.isSag === true || authSettings.isOrgAdmin === true) {
                window.location.href = '/s4s/CustomPage/Index/151';
            } else if (authSettings.isEmployee === true || authSettings.isEmployer === true) {
                const mainContainer = document.getElementById('maincontent')
                const script = document.createElement('script');
                script.defer = true;
                script.crossOrigin = '';
                script.src = '/Resources/CORE-UI/ppl-connect-dashboard.min.js';
                document.head.appendChild(script);
            
                const container = document.createElement('div');
                container.className = 'container connect-dashboard';
                container.innerHTML = `
                    <h1 class="sr-only">Dashboard</h1>
                    <sc-ppl-connect-dashboard></sc-ppl-connect-dashboard>
                `;

                mainContainer.appendChild(container);
            }
            
        },

        bindUIActions: function () {

        },

        unload: function () {},
    };

    Attributes.init();
})();